import Cookies from 'universal-cookie';

export interface ICookieData {
  name: string;
  value: string;
  days?: number;
}

export function setCookie(name: string, value: string, days?: number) {
  const cookies = new Cookies();

  const options = days
    ? { expires: new Date(Date.now() + days * 864e5) }
    : undefined;

  cookies.set(name, value, options);
}
export function getCookies(props:string) {
    const cookies = new Cookies();
    return cookies.get(props);
}

export function removeCookie(name: string) {
    const cookies = new Cookies();
    cookies.remove(name);
}